import React, { useContext } from "react";
import { Grid, Button, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { LangContext } from "../../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  btnstyle: {
    margin: "1rem",
    borderRadius: 8,
    padding: "0.5rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    marginTop: "2rem",
    "&:hover": {
      background: "#e16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  textfield: {
    "& .MuiOutlinedInput-input": {
      padding: "15px 14px",
    },
  },
  inputStyle: {
    fontWeight: 200,
    fontSize: "1rem",
  },
  inputLabelStyle: {
    fontWeight: 400,
    fontSize: "1rem",
    transform: "translate(14px, 16px) scale(1)",
  },
  form: {
    width: "100%",
    padding: "2.5rem 0rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  root: {
    maxWidth: "85%",
  },
}));

const Formenterprise = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  return (
    <form className={classes.form}>
      <Grid container spacing={3} className={classes.root}>
        <Grid item md={6} sm={6} xs={12}>
          <TextField
            id="outlined-name"
            label={lang.Name}
            variant="outlined"
            fullWidth
            className={classes.textfield}
            inputProps={{
              className: classes.inputStyle,
            }}
            InputLabelProps={{
              className: classes.inputLabelStyle,
            }}
          />
        </Grid>

        <Grid item md={6} sm={6} xs={12}>
          <TextField
            id="outlined-lastname"
            label={lang.Lastname}
            variant="outlined"
            fullWidth
            className={classes.textfield}
            inputProps={{
              className: classes.inputStyle,
            }}
            InputLabelProps={{
              className: classes.inputLabelStyle,
            }}
          />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <TextField
            id="outlined-email"
            label={lang.Email}
            variant="outlined"
            fullWidth
            className={classes.textfield}
            inputProps={{
              className: classes.inputStyle,
            }}
            InputLabelProps={{
              className: classes.inputLabelStyle,
            }}
          />
        </Grid>

        <Grid item md={6} sm={6} xs={12}>
          <TextField
            id="outlined-tel"
            label={lang.Tel}
            variant="outlined"
            fullWidth
            className={classes.textfield}
            inputProps={{
              className: classes.inputStyle,
            }}
            InputLabelProps={{
              className: classes.inputLabelStyle,
            }}
          />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <TextField
            id="outlined-company"
            label={lang.Company}
            variant="outlined"
            fullWidth
            className={classes.textfield}
            inputProps={{
              className: classes.inputStyle,
            }}
            InputLabelProps={{
              className: classes.inputLabelStyle,
            }}
          />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <TextField
            id="outlined-website"
            label={lang.Website}
            variant="outlined"
            fullWidth
            className={classes.textfield}
            inputProps={{
              className: classes.inputStyle,
            }}
            InputLabelProps={{
              className: classes.inputLabelStyle,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="outlined-require"
            label={lang.Requirement}
            variant="outlined"
            fullWidth
            multiline={true}
            rows={9}
            rowsMax={9}
            inputProps={{
              className: classes.inputStyle,
            }}
            InputLabelProps={{
              className: classes.inputLabelStyle,
            }}
          />
        </Grid>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <Button className={classes.btnstyle}>{lang.SendMessage}</Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default Formenterprise;
